export const getStyles = ({ isDragActive }: { isDragActive: boolean }) => {
	return {
		container: {
			backgroundColor: isDragActive ? 'rgba(89, 119, 235, 0.04);' : '#FFFFFF',
			border: isDragActive ? '2px dashed #5977EB' : 'none',
			borderRadius: '9px',
			height: '100%',
		},
	};
};
